// Messages for design-system/components/ConfirmDialog (auto-merged by lib/i18n.ts).
export const en = {
  'confirm.cancel': 'Cancel',
  'confirm.working': 'Working…',
}

export const zhTW = {
  'confirm.cancel': '取消',
  'confirm.working': '處理中…',
}
